import { makeStyles } from '@material-ui/core';

// Lighter than the theme's divider, which is faint enough to disappear on a
// stream. Both the rules between columns and the lines between rows use it, so a
// ruled table reads as one grid.
const RULE_COLOR = 'rgba(255, 255, 255, 0.32)';

// Rules between the columns of a table, so a row of numbers is read against the
// heading it belongs under.
//
// The cells are matched by their material-ui class rather than as th and td: a
// table whose cells are links renders each one as an anchor inside a td that is
// display: contents, and a border on that td would never be painted. The last
// column of a row is the one that goes without, whichever of the two shapes it
// has.
const useTableRules = makeStyles({
    ruled: {
        '& .MuiTableCell-root': {
            borderRight: `1px solid ${RULE_COLOR}`,
            borderBottomColor: RULE_COLOR
        },
        '& tr > :last-child, & tr > :last-child .MuiTableCell-root': {
            borderRight: 'none'
        }
    }
});

export default useTableRules;
